import { useEffect } from "react";

export const SITE_URL = "https://hts-janzen.de";

export const routesMeta = {
  "/": {
    title: "Hausverwaltung Kleve & Niederrhein | WEG-Verwaltung – HTS Janzen",
    description:
      "HTS Janzen – Ihre persönliche Hausverwaltung in Kleve und am Niederrhein. WEG-Verwaltung, Jahresabrechnung, Wirtschaftsplan und Eigentümerversammlungen mit festem Ansprechpartner.",
  },
  "/weg-verwaltung-kleve": {
    title: "WEG-Verwaltung in Kleve und am Niederrhein | HTS Janzen",
    description:
      "Kaufmännische, technische und organisatorische WEG-Verwaltung für kleine und mittelgroße Eigentümergemeinschaften in Kleve und am Niederrhein. Jahresabrechnung, Wirtschaftsplan, Eigentümerversammlungen, Instandhaltung.",
  },
  "/verwalterwechsel": {
    title: "Verwalterwechsel in 4 Schritten | HTS Janzen Hausverwaltung",
    description:
      "So einfach wechseln Sie die Hausverwaltung: Erstgespräch, Beschluss der Eigentümerversammlung, Übernahme der Unterlagen, Start mit festem Ansprechpartner. Auch kurzfristig möglich.",
  },
  "/faq": {
    title: "Häufige Fragen zur Hausverwaltung | HTS Janzen",
    description:
      "Antworten auf häufige Fragen zur WEG-Verwaltung: Kosten, Verwalterwechsel, Mindestgröße, betreute Orte und Erreichbarkeit im Notfall.",
  },
  "/impressum": { title: "Impressum | HTS Janzen Hausverwaltung", description: "Impressum der HTS Janzen Hausverwaltung, Mergelkamp 6, 47559 Kranenburg." },
  "/datenschutz": { title: "Datenschutzerklärung | HTS Janzen Hausverwaltung", description: "Datenschutzerklärung der HTS Janzen Hausverwaltung." },
};

const setMeta = (selector, attr, value) => {
  const el = document.head.querySelector(selector);
  if (el) el.setAttribute(attr, value);
};

export const useSeo = (path) => {
  useEffect(() => {
    const meta = routesMeta[path];
    if (!meta) return;
    document.title = meta.title;
    setMeta('meta[name="description"]', "content", meta.description);
    setMeta('link[rel="canonical"]', "href", `${SITE_URL}${path === "/" ? "/" : path}`);
    setMeta('meta[property="og:title"]', "content", meta.title);
    setMeta('meta[property="og:description"]', "content", meta.description);
    setMeta('meta[property="og:url"]', "content", `${SITE_URL}${path === "/" ? "/" : path}`);
  }, [path]);
};
